import React from 'react';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';

import propTypes from '../../../common/propTypes';
import SocialAccountPageContent from './SocialAccountPageContent';

@withRouter
export default class SocialAccountPage extends React.PureComponent {
  static propTypes = {
    type: propTypes.socialAccountType.isRequired,
    ...propTypes.routePropTypes,
  };

  static defaultProps = {};

  renderContent = () => {
    const { type } = this.props;
    return <SocialAccountPageContent type={type} />;
  };

  renderCompletionContent = () => {
    const { type, match } = this.props;
    return (
      <SocialAccountPageContent afterCompletionPath={match.url} type={type} />
    );
  };

  render() {
    const { match } = this.props;

    return (
      <Switch>
        <Route
          path={`${match.url}/complete`}
          render={this.renderCompletionContent}
        />
        <Route path={`${match.url}`} render={this.renderContent} />
        <Redirect to={match.url} />
      </Switch>
    );
  }
};
